<template>
  <div class="pega-login-container grid-y">
    <div class="cell">
      <div class="grid-x align-center">
        <div class="cell large-5 medium-8 small-10 pega-login-content">
          <div class="text-center">
            <div class="font-bold">
              正社員で長く働きたい女性のための転職サイト <span class="text-nowrap">【女の転職タイプ】</span>
            </div>
            <img
              class="pega-logo margin-bottom-2"
              src="@/assets/images/uki-logo.png"
            >
          </div>
          <validation-label
            v-if="error"
            class="login-form-error"
            :label="error"
            data-test="error-text"
          />
          <form @submit.prevent="login">
            <div class="form-group margin-bottom-1">
              <label
                class="boss-color-white"
                data-test="login-id"
              >ログインID：{{ loginId }}</label>
            </div>
            <p class="margin-0 pega-font-size-min-rem">
              メールアドレス
            </p>
            <div class="form-group">
              <input
                v-model="email"
                name="email"
                autocomplete="new-password"
                type="email"
                placeholder="メールアドレス"
                data-test="email"
              >
            </div>
            <p class="margin-0 pega-font-size-min-rem">
              仮パスワード
            </p>
            <div class="form-group">
              <input
                v-model="temporaryPassword"
                name="temporaryPassword"
                autocomplete="new-password"
                type="password"
                placeholder="仮パスワード"
                data-test="temporary-password"
              >
            </div>
            <div
              v-if="isRequiredAuthenticationCode"
              class="form-group"
            >
              <p class="margin-0 pega-font-size-min-rem">
                認証番号
              </p>
              <input
                v-model="authentication"
                name="authentication"
                type="number"
                max="9999"
                min="0"
                placeholder="認証番号"
                data-test="authentication-code"
                @keypress="onlyNumberInRange($event, 9999)"
              >
            </div>
            <div class="form-group">
              <p class="margin-0 pega-font-size-min-rem">
                新パスワード
              </p>
              <input
                v-model="newPassword"
                name="newPassword"
                :class="{ 'is-invalid-input login-form-error': isInvalidPassword || isSameTemporaryAndNewPassword }"
                type="password"
                placeholder="新パスワード"
                data-test="new-password"
              >
              <validation-label
                v-if="isInvalidPassword"
                class="login-form-error"
                label="半角英数混在8文字以上20文字以内で入力してください。"
                data-test="new-password-validation"
              />
              <validation-label
                v-if="isSameTemporaryAndNewPassword"
                class="login-form-error"
                label="仮パスワードと異なるものを入力してください。"
                data-test="is-same-temporary-and-new-password"
              />
            </div>
            <div class="form-group">
              <p class="margin-0 pega-font-size-min-rem">
                新パスワード（確認用）
              </p>
              <input
                v-model="confirmNewPassword"
                name="confirmNewPassword"
                :class="{ 'is-invalid-input login-form-error': isDifferentNewPassword }"
                type="password"
                placeholder="新パスワード（確認用）"
                data-test="confirm-new-password"
              >
              <validation-label
                v-if="isDifferentNewPassword"
                class="login-form-error"
                label="新パスワードと新パスワード(確認用)が一致しません。"
                data-test="is-same-new-password-confirm"
              />
            </div>
            <button
              :disabled="isDisable"
              class="float-center boss-button-center pega-login-button pega-button"
              type="submit"
              data-test="login-button"
            >
              ログイン
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import eventValidations from '@/lib/eventValidations'
import ValidationLabel from '@/components/atoms/ValidationLabel'
import { mapActions } from 'vuex'

export default {
  components: {
    ValidationLabel
  },
  mixins: [eventValidations],
  data () {
    return {
      loginId: '',
      isRequiredAuthenticationCode: false,
      email: '',
      temporaryPassword: '',
      authentication: '',
      newPassword: '',
      confirmNewPassword: '',
      error: ''
    }
  },
  computed: {
    isInvalidPassword () {
      // 半角英数混在8文字以上20文字以内のチェック（空の場合は入力チェックをしない）
      return !_.isEmpty(this.newPassword) && !(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,20}$/i).test(this.newPassword)
    },
    isSameTemporaryAndNewPassword () {
      return !_.isEmpty(this.temporaryPassword) && this.temporaryPassword === this.newPassword
    },
    isDifferentNewPassword () {
      return !_.isEmpty(this.confirmNewPassword) && this.newPassword !== this.confirmNewPassword
    },
    isDisable () {
      return !_.isEmpty(this.error) ||
          _.isEmpty(this.email) ||
          _.isEmpty(this.temporaryPassword) ||
          (this.isRequiredAuthenticationCode && _.isEmpty(this.authentication)) ||
          _.isEmpty(this.newPassword) ||
          _.isEmpty(this.confirmNewPassword) ||
          this.isInvalidPassword ||
          this.isSameTemporaryAndNewPassword ||
          this.isDifferentNewPassword
    }
  },
  created () {
    this.fetchLoginParam()
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    login () {
      this.$http.plain.post('api/login/first', {
        loginId: this.loginId,
        email: this.email,
        temporaryPassword: this.temporaryPassword,
        authenticationCode: this.authentication,
        loginPassword: this.newPassword
      }).then(response => {
        this.fetchAllMasters()
        this.fetchExistsSeminarEntry()
        this.fetchStaffInfo().then(response => {
          this.$store.dispatch('setCurrentUser', { currentUser: response.data })
          // ダミー権限が有効な場合ダミー画面へ
          response.data.permissions.isCountScoutUserSimulation ? this.$router.push({ name: 'dummyTop' }) : this.$router.push({ name: 'dashboardTop' })
        })
      }).catch((error) => {
        const status = _.get(error, 'response.data.status')
        const message = _.get(error, 'response.data.message')
        this.$toasted.global.error({ message: status === 403 ? message : 'ログインに失敗しました。' })
      })
    },
    fetchLoginParam () {
      this.$http.plain.get(`api/login_param/${this.$route.query.id}`)
        .then(
          response => {
            this.$set(this, 'loginId', response.data.loginId)
            this.$set(this, 'isRequiredAuthenticationCode', response.data.isRequiredAuthenticationCode)
          }
        )
        .catch(
          error => {
            this.$set(this, 'error', error.response.data.message)
          }
        )
    },
    fetchAllMasters () {
      const masters = [
        'genders',
        'educationalBackgrounds',
        'educationalDepartments',
        'prefectures',
        'occupations',
        'skills',
        'licenses',
        'specialFavors',
        'businesses',
        'employmentStatuses',
        'languages',
        'languageSkills',
        'optionalPermissions',
        'workStyles'
      ]
      masters.forEach(element => {
        this.storeMaster(element)
      })
    },
    fetchStaffInfo () {
      return this.$http.secured.get('/staff_info')
    },
    fetchExistsSeminarEntry () {
      return this.$http.secured.get('/seminar/exists').then(response => {
        this.$store.dispatch('setIsExistsSeminar', response.data)
      })
    }
  }
}
</script>
